import store from "../store/index.js";
import http from "../h5-network/request.js";
import qs from "qs";
let { channelCode } = qs.parse(location.search.slice(1));
export const saveLG = function ({ method, productName, userAnswer }) {
    /* method: {
        1: 测评后预约
        2: 一对一 APP
        4: 测评完成
        5: 未完成测评
    } */

    let data = {
        code: channelCode || 'QT',
        method,
        "orderOfflineOutRemarkReq": {
            "insuranceArray": [
                {
                    "product_Code": "",
                    "product_name": productName
                }
            ],
        },
        phone: store.state.relateInfo?.phone,
    }

    userAnswer && (data.userAnswer = userAnswer);

    return http({
        loading: true,
        url: '/bdzb-core-service/lg/saveOfflineOrderInfo',
        data,
        method: 'POST',
    })
}